export default __webpack_public_path__ + "3653eb905f1d05476f87a83770740d9a.png";